angular.module('unica_tools.tools_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// RELATOR
		.state('app.tools', {
			url: '/tools',
			abstract: true,
			views: {
				'mainContent': {
					templateUrl: './modules/tools/templates/tools.html',
					controller: 'ToolsBasicController'
				}
			},
			params: {
				need_auth: true
			}
		})

		// RELATOR LIST AND DELETE
		.state('app.tools.list', {
			url: '/list',
			views: {
				'toolsContent': {
					templateUrl: './modules/tools/templates/list.html',
					controller: 'ToolsListController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Tools'
			}
		})

	// RELATOR LIST AND DELETE
	.state('app.tools.qrcode', {
		url: '/qrcode',
		views: {
			'toolsContent': {
				templateUrl: './modules/tools/templates/qrcode.html',
				controller: 'ToolsQrcodeController'
			}
		},
		params: {
			need_auth: true
		},
		ncyBreadcrumb: {
			label: 'Qrcode',
			parent: 'app.tools.list'
		}
	});



});

